// Small navigation enhancements; commerce uses the theme's native Shopify components.
(() => {
  if (document.body.classList.contains('pp-home')) {
    let headerObserver;
    let framePending = false;

    const updateHeader = () => {
      framePending = false;
      // Horizon scrolls .page-wrapper on desktop and the document on mobile.
      const scrollTop = Math.max(document.querySelector('.page-wrapper')?.scrollTop || 0, window.scrollY);
      document.body.classList.toggle('pp-header-scrolled', scrollTop > 8);
    };
    const scheduleHeaderUpdate = () => {
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(updateHeader);
    };
    const measureHeader = () => {
      for (const [selector, property] of [
        ['.pp-header', '--pp-header-height'],
        ['.pp-announcement', '--pp-announcement-height'],
      ]) {
        const element = document.querySelector(selector);
        if (!element) continue;
        const value = `${element.getBoundingClientRect().height}px`;
        if (document.body.style.getPropertyValue(property) !== value) document.body.style.setProperty(property, value);
      }
      scheduleHeaderUpdate();
    };
    const connectHeader = () => {
      headerObserver?.disconnect();
      headerObserver = new ResizeObserver(measureHeader);
      document.querySelectorAll('.pp-header, .pp-announcement').forEach(element => headerObserver.observe(element));
      measureHeader();
    };

    document.addEventListener('scroll', scheduleHeaderUpdate, { capture: true, passive: true });
    window.addEventListener('pageshow', scheduleHeaderUpdate);
    window.addEventListener('resize', scheduleHeaderUpdate, { passive: true });
    document.addEventListener('shopify:section:load', connectHeader);
    connectHeader();
    updateHeader();
  }

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    for (const menu of document.querySelectorAll('.pp-mega[open], .pp-mobile-menu[open]')) {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });
  document.addEventListener('click', event => {
    for (const menu of document.querySelectorAll('.pp-mega[open], .pp-mobile-menu[open]')) {
      if (!menu.contains(event.target)) menu.open = false;
    }
  });
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.('.pp-mega, .pp-mobile-menu') || !event.target.open) return;
    for (const menu of document.querySelectorAll('.pp-mega[open], .pp-mobile-menu[open]')) {
      if (menu !== event.target) menu.open = false;
    }
  }, true);
})();
